import { Box, Typography, styled } from "@mui/material";
import { CustomDisplayItem } from "@/components/custom/custom-display-item";
const Row = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  [theme.breakpoints.up("lg")]: { flexDirection: "row" },
}));

const Side = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  [theme.breakpoints.up("lg")]: { width: 256 },
}));

const Grid = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: theme.spacing(2),
  [theme.breakpoints.up("md")]: { gridTemplateColumns: "1fr 1fr" },
}));

const formatBoolean = (val) => {
  if (val === true) return "Yes";
  if (val === false) return "No";
  return "-";
};

export const ProfileAccount = ({ data }) => {
  return (
    <Row>
      <Side>
        <Typography fontWeight={500} fontSize={18}>
          Account Status & Security
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Overview of account health and security settings.
        </Typography>
      </Side>
      <Grid>
        <Box sx={{ backgroundColor: "background.default" }}>
          <CustomDisplayItem
            label="Account Active"
            value={formatBoolean(data?.active)}
          />
        </Box>
        <Box sx={{ backgroundColor: "background.default" }}>
          <CustomDisplayItem
            label="Account Status"
            value={data?.accountStatus === 1 ? "Active" : "Inactive"}
          />
        </Box>
        <Box sx={{ backgroundColor: "background.default" }}>
          <CustomDisplayItem
            label="2FA Enabled"
            value={formatBoolean(data?.["2fa"])}
          />
        </Box>
      </Grid>
    </Row>
  );
};
